
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M19 3h-6.528a1.019 1.019 0 01-.447-.1L8.869 1.316A3.014 3.014 0 007.528 1H5a5.006 5.006 0 00-5 5v12a5.006 5.006 0 005 5h14a5.006 5.006 0 005-5V8a5.006 5.006 0 00-5-5zM5 3h2.528a1.019 1.019 0 01.447.1l3.156 1.579A3.014 3.014 0 0012.472 5H19a3 3 0 012.779 1.882L2 6.994V6a3 3 0 013-3zm14 18H5a3 3 0 01-3-3V8.994l20-.113V18a3 3 0 01-3 3z"}})])
          )
        }
      }
    